import { render, staticRenderFns } from "./ImportDeck.vue?vue&type=template&id=998163a0&scoped=true&"
import script from "./ImportDeck.vue?vue&type=script&lang=js&"
export * from "./ImportDeck.vue?vue&type=script&lang=js&"
import style0 from "./ImportDeck.vue?vue&type=style&index=0&id=998163a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998163a0",
  null
  
)

export default component.exports